export const ICON_SIZE = {
    xxxxs: 4,
    xxxs: 6,
    xxs: 16,
    xs: 20,
    s: 24,
    m: 32,
    sm: 36,
    xm: 40,
    l: 48,
    xl: 56,
    xxl: 64,
    xxxl: 82,
    xxxxl: 96,
    xxxxxl: 120,
};
